import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

import { InputField } from '@/shared/ui/input-field';
import { ColumnFlexBox } from '@/shared/ui/layout';

export const ModalBodyContainer = styled(ColumnFlexBox)(({ theme }) => ({
  gap: theme.spacing(5),
  padding: theme.spacing(6),
  borderRadius: theme.spacing(3),
  marginBottom: theme.spacing(8.5),
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(4),
    padding: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
}));

export const CustomInput = styled(InputField)(({ theme }) => ({
  margin: 0,
  '& .MuiOutlinedInput-input': { padding: theme.spacing(2.5) },
  '& .MuiInputLabel-root': { color: theme.customColors.black50, fontSize: 18, top: '-5px' },
  '& .MuiInputBase-root': { borderRadius: 6 },
}));

export const ModalButton = styled(Button)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '100%',
  padding: theme.spacing(4, 0),
  borderRadius: theme.spacing(2),
  color: theme.palette.background.paper,
  backgroundColor: theme.customColors.primary100,
  '&:hover': {
    backgroundColor: theme.customColors.purple80,
  },
}));
